import script from "./HistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryView.vue?vue&type=script&setup=true&lang=js"

import "./HistoryView.vue?vue&type=style&index=0&id=6f8d2865&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f8d2865"]])

export default __exports__